<template>
    <dash
        icon="fa fa-book"
        titulo="PROJETOS SGTEC"
        subTitulo="UABS"
        @click.native="$router.push({ name: 'Sgtec_Uabs_Projetos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
